@if (label) {
  <label class="bv-form-field__label">{{ label }}</label>
}
<div class="bv-form-field__control">
  <ng-content></ng-content>
</div>
@if (error) {
  <div class="bv-form-field__error">{{ error }}</div>
}
@if (hint && !error) {
  <div class="bv-form-field__hint">{{ hint }}</div>
}
